export default "__VITE_ASSET__CbIz5y$8__"